import React from "react";
import { useBnbSelector } from "../../../redux/store";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import * as Styles from "./nav/styles/BuildStepNavigation";
import * as Text from "../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import { BnbLabel } from "../../../utils/labels";
import { getModelMapValueById } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { enableCheckoutSteps, showServicesStep } from "../../../utils/settings/bnbSettingUtils";
import { checkoutStepIsActive } from "../../../utils/checkoutUtils";
import { trackNavGoToStep } from "../../../utils/tracking";
import useStepUrl from "../../../hooks/shared/actions/useStepUrl";

// Very similar to the V1s BuildNavigationItems, but with different icons and the services step
const BuildNavigationItems = (): JSX.Element => {
    const navigation = useBnbSelector((state) => state.navigation);
    const car = useBnbSelector((state) => state.car);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const enableCheckoutStep = enableCheckoutSteps(bnbSettings, commonSettings);

    const { step, model } = navigation;

    const checkoutStepisActive = checkoutStepIsActive(step);

    const modelName = getModelMapValueById(commonSettings, model, false)?.name;

    const showServices = showServicesStep(bnbSettings, commonSettings);

    const submodelStep = useStepUrl(NavStep.Submodels, undefined, undefined, () =>
        trackNavGoToStep(step, NavStep.Submodels),
    );

    const gradesStep = useStepUrl(
        NavStep.Grades,
        step !== NavStep.Submodels
            ? {
                  modelId: model,
                  subModelId: car.submodel?.id,
              }
            : undefined,
        undefined,
        () => trackNavGoToStep(step, NavStep.Grades),
    );

    const customizeStep = useStepUrl(NavStep.Customize, undefined, undefined, () =>
        trackNavGoToStep(step, NavStep.Customize),
    );

    const servicesStep = useStepUrl(NavStep.Services, undefined, undefined, () =>
        trackNavGoToStep(step, NavStep.Services),
    );

    const summaryStep = useStepUrl(NavStep.Summary, undefined, undefined, () =>
        trackNavGoToStep(step, NavStep.Summary),
    );

    return (
        <Styles.Wrapper>
            <a
                href={submodelStep.href}
                onClick={submodelStep.onClick}
                aria-current={step === NavStep.Submodels ? "location" : "false"}
                data-testid="internalLink"
            >
                <Styles.Step isActive={step === NavStep.Submodels}>
                    <Styles.StepInner isActive={step === NavStep.Submodels}>
                        <Styles.Icon isActive={step === NavStep.Submodels}>01</Styles.Icon>
                        <Text.Style textTransform="none">{modelName}</Text.Style>
                    </Styles.StepInner>
                </Styles.Step>
            </a>

            <a
                href={gradesStep.href}
                onClick={gradesStep.onClick}
                aria-current={step === NavStep.Grades ? "location" : "false"}
                data-testid="internalLink"
            >
                <Styles.Step isActive={step === NavStep.Grades}>
                    <Styles.StepInner isActive={step === NavStep.Grades}>
                        <Styles.Icon isActive={step === NavStep.Grades}>02</Styles.Icon>
                        {car.id ? (
                            <Text.Style textTransform="none">{car.grade.name}</Text.Style>
                        ) : (
                            <BnbLabel label="stepGrade" />
                        )}
                    </Styles.StepInner>
                </Styles.Step>
            </a>

            <a
                href={customizeStep.href}
                onClick={customizeStep.onClick}
                aria-current={step === NavStep.Customize ? "location" : "false"}
                data-testid="internalLink"
            >
                <Styles.Step isActive={step === NavStep.Customize}>
                    <Styles.StepInner isActive={step === NavStep.Customize}>
                        <Styles.Icon isActive={step === NavStep.Customize}>03</Styles.Icon>
                        <BnbLabel label="stepCustomise" />
                    </Styles.StepInner>
                </Styles.Step>
            </a>

            {showServices && (
                <a
                    href={servicesStep.href}
                    onClick={servicesStep.onClick}
                    aria-current={step === NavStep.Services ? "location" : undefined}
                    data-testid="internalLink"
                >
                    <Styles.Step isActive={step === NavStep.Services}>
                        <Styles.StepInner isActive={step === NavStep.Services}>
                            <Styles.Icon isActive={step === NavStep.Services}>04</Styles.Icon>
                            <BnbLabel label="stepServices" />
                        </Styles.StepInner>
                    </Styles.Step>
                </a>
            )}

            <a
                href={summaryStep.href}
                onClick={summaryStep.onClick}
                aria-current={step === NavStep.Summary ? "location" : undefined}
                data-testid="internalLink"
            >
                <Styles.Step isActive={step === NavStep.Summary}>
                    <Styles.StepInner isActive={step === NavStep.Summary}>
                        {showServices ? (
                            <Styles.Icon isActive={step === NavStep.Summary}>05</Styles.Icon>
                        ) : (
                            <Styles.Icon isActive={step === NavStep.Summary}>04</Styles.Icon>
                        )}
                        <BnbLabel label="stepSummaryAndSave" />
                    </Styles.StepInner>
                </Styles.Step>
            </a>

            {enableCheckoutStep && (
                <Styles.StepWithoutLink>
                    <Styles.Step
                        isActive={checkoutStepisActive}
                        aria-current={checkoutStepisActive ? "location" : undefined}
                    >
                        <Styles.StepInner isActive={checkoutStepisActive}>
                            {showServices ? (
                                <Styles.Icon isActive={checkoutStepisActive}>06</Styles.Icon>
                            ) : (
                                <Styles.Icon isActive={checkoutStepisActive}>05</Styles.Icon>
                            )}
                            {/* To Check: New label for lease? */}
                            <BnbLabel label="checkoutStep" fallbackLabel="stepBuy" />
                        </Styles.StepInner>
                    </Styles.Step>
                </Styles.StepWithoutLink>
            )}
        </Styles.Wrapper>
    );
};

export default BuildNavigationItems;
